import { Building2, Calendar, MapPin } from "lucide-react";

const roles = [
  {
    current: true,
    title: "Principal Security Engineer",
    company: "DigiNova Tech Global Pvt. Ltd.",
    period: "Jul 2026 – Present",
    location: "Mumbai",
    description: "Building and scaling DigiNova's cybersecurity practice from the ground up. Owns delivery across EDR, NG-SIEM, Security Automation, DLP, Identity Protection, and Cloud Security. Building and leading the security team, maintaining OEM relationships, staying in sync with distributors, and engaging C-level stakeholders (CISO/CIO/CTO/CFO) for requirements gathering. Leading pre-sales calls, presentations, SoW, and RFP review.",
  },
  {
    current: false,
    title: "Senior Security Engineer",
    company: "Tecplix Technologies Pvt. Ltd.",
    period: "Dec 2025 – Jun 2026",
    location: "Mumbai",
    description: "Led enterprise security deployments — Cloud Security, Identity Protection, NG-SIEM. Designed scalable security frameworks and integrated cloud/identity controls across large-scale environments.",
  },
  {
    current: false,
    title: "Lead Solution Specialist",
    company: "ACPL Systems Pvt. Ltd.",
    period: "Jan 2022 – Dec 2025",
    location: "Delhi NCR",
    description: "Spearheaded 50+ full-cycle PoCs across EDR, Identity, SIEM, and Cloud Security. Managed 2.1M+ endpoint deployments across large enterprise clients. Recognized as CrowdStrike APJ MVP Partner 2023–24.",
  },
];

export default function Experience() {
  return (
    <section id="experience" className="py-20 md:py-32 bg-white" data-testid="experience-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">Career</span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-bold tracking-tight text-[#111827] mt-3">
            Experience
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-6">
          {roles.map((role) => (
            <div
              key={role.company}
              className="bg-white border border-[#E5E7EB] rounded-2xl p-6 md:p-8 card-hover relative"
              data-testid={`experience-card-${role.company.slice(0, 10).toLowerCase().replace(/\s+/g, '-')}`}
            >
              {role.current && (
                <span className="absolute top-4 right-4 inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-green-50 text-green-600 border border-green-200">
                  Current
                </span>
              )}
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#06B6D4]/10 flex items-center justify-center shrink-0 mt-0.5">
                  <Building2 className="w-5 h-5 text-[#06B6D4]" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-['Outfit'] text-lg font-bold text-[#111827]">{role.title}</h3>
                  <p className="text-sm font-medium text-[#06B6D4] mt-0.5">{role.company}</p>
                  <div className="flex flex-wrap items-center gap-3 mt-2 text-xs text-[#6B7280]">
                    <span className="inline-flex items-center gap-1">
                      <Calendar className="w-3.5 h-3.5" /> {role.period}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <MapPin className="w-3.5 h-3.5" /> {role.location}
                    </span>
                  </div>
                  <p className="text-sm text-[#6B7280] leading-relaxed mt-3">{role.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
